import { render, staticRenderFns } from "./dashboard-aytomadrid.vue?vue&type=template&id=28e9a814"
import script from "./dashboard-aytomadrid.vue?vue&type=script&lang=js"
export * from "./dashboard-aytomadrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports